module.exports = __webpack_public_path__ + "img/watch-1.d7edd857.png";